import ImprintPage from '~brand-pages/lufthansa/imprint'
import brandConfig from '~branding/lufthansa/config.js'
import TermsOfUsePage from '~brand-pages/lufthansa/terms-of-use'
import TermsOfUsePageCompensation from '~brand-pages/lufthansa/terms-of-use-compensation'
import VoucherSaleAmountPage from '~brand-pages/lufthansa/voucher-sale-amount'
import VoucherSaleCheckoutPage from '~brand-pages/lufthansa/voucher-sale-checkout'
import VoucherSaleConfirmationPage from '~brand-pages/lufthansa/voucher-sale-confirmation'
import VoucherSaleLandingPage from '~brand-pages/lufthansa/voucher-sale'
import routerBuilder from './routerBuilder'

const lhRouter = (defaultLocale = 'de') => routerBuilder('lufthansa', {
  brandConfig,
  ImprintPage,
  TermsOfUsePage,
  TermsOfUsePageCompensation,
  VoucherSaleAmountPage,
  VoucherSaleCheckoutPage,
  VoucherSaleConfirmationPage,
  VoucherSaleLandingPage,
},
['de', 'en'], defaultLocale)

export default lhRouter
